<template>
  <div class="flex flex-wrap -mx-2 text-sm items-stretch pb-10">
    <div class="flex-1 w-full px-4">
      <h1 slot="header" class="w-full text-lg py-4">
        Biography Text
      </h1>
      <div class="w-full pb-6">
        <p class="leading-normal">Please enter some information about yourself that will be displayed on the Meet the Team page(s) on the website, and as your “Agent Profile” in Sales Particulars when using the Bespoke Marketing Suite. For an example of the type of information we would suggest you include please follow the link to our <a href="https://my.corebook.io/fineandcountry/personal-presentation/biography" target="_blank" class="text-blue">Biography Guidelines.</a><strong> Please ensure you check spelling and grammar before saving</strong></p>
      </div>
      <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-2">
        <div class="w-full lg:w-1/2 px-2 mb-4">
          <div class="flex justify-between">
            <div><label for="website_biography" class="text-sm font-bold">Website Biography:</label></div>
            <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false">
              Character Count Limit:
              <span class="ml-2" :class="{'text-red': value.userApproval.website_biography.en.length === 5000, 'text-green': value.userApproval.website_biography.en.length < 5000 }"> {{value.userApproval.website_biography ? value.userApproval.website_biography.en.length : 0 }} / 5,000</span>
            </div>
            <div v-else>
              Character Count Limit:
              <span class="ml-2" :class="{ 'text-red': value.website_biography.en.length === 5000, 'text-green': value.website_biography.en.length < 5000 }"> {{ value.website_biography.en ? value.website_biography.en.length : 0 }} / 5,000</span>
            </div>
          </div>
          <textarea v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}" type="text" id="website_biography" maxlength="5000" v-model="value.userApproval.website_biography.en" class="block w-full border p-2 mt-2 text-sm leading-normal" rows="15" placeholder="Paste your biography text in here"></textarea>
          <textarea v-else type="text" id="website_biography" maxlength="5000" v-model="value.website_biography.en" class="block w-full border p-2 mt-2 text-sm leading-normal" rows="15" placeholder="Paste your biography text in here"></textarea>

        </div>

        <div  v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="w-full lg:w-1/2 px-2 mb-4">
          <div class="flex justify-between">
            <div><label for="self_biography" class="text-sm font-bold">Sales Particulars Biography:</label></div>
            <div>
              Character Count Limit:
              <span class="ml-2" :class="{'text-red': value.userApproval.self_biography.en.length === 420, 'text-green': value.userApproval.self_biography.en.length < 420 }"> {{value.userApproval.self_biography.en ? value.userApproval.self_biography.en.length : 0 }} / 420</span>
            </div>

          </div>
          <textarea :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}" type="text" id="self_biography" maxlength="420" v-model="value.userApproval.self_biography.en" class="block w-full border p-2 mt-2 text-sm leading-normal" rows="15" placeholder="Paste your biography text in here"></textarea>
        </div>
      </div>
      <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="mb-4 ml-2 w-full">Alternate language biographies will only be visible on sites that support that language.</div>
      <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="flex flex-row">
        <div class="w-1/2 text-xs border-grey-lighter mb-4">
        <!-- start of website bio -->
          <div v-for="(bio, name, index) in additionalLanguagesBio" :key="index" :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}">
            <div class="w-full px-2 mb-4">
              <div class="flex justify-between mb-1">
                <div><label for="website_biography" class="text-sm font-bold">Website Biography - {{availableLangauges[name]}}:</label></div>
                <div>
                  <button class="rounded py-2 px-4 bg-grey flex items-center ml-4 hover:bg-grey-dark" @click="removeBios(name, 'web_bio')"><icon :center="false" name="close_small" class="h-4 w-4"></icon>Delete</button>
                </div>
              </div>
              <div class="flex w-full justify-end">
                <div>
                  Character Count Limit:
                  <span class="ml-2" :class="{'text-red': value.userApproval.website_biography[name].length === 5000, 'text-green': value.userApproval.website_biography[name].length < 5000 }"> {{value.userApproval.website_biography ? value.userApproval.website_biography[name].length : 0 }} / 5,000</span>
                </div>
              </div>
              <textarea :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}" type="text" id="website_biography" maxlength="5000" v-model="value.userApproval.website_biography[name]" class="block w-full border p-2 mt-2 text-sm leading-normal" rows="15" placeholder="Paste your biography text in here"></textarea>
            </div>
          </div>
          <div v-if="Object.keys(value.userApproval.website_biography).length < 5" class="w-full px-2 mb-2 flex justify-end items-center">
            <div class="font-bold text-sm mr-4">Add a translation:</div>
            <div>
              <select :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}" v-model="biosSelected" @change="addWebBio(biosSelected)" class="text-base px-4 py-2 bg-white border hover:bg-grey-light cursor-pointer" name="language" id="language">
                <option :value="null" disabled>Select Language</option>
                <option v-for="(value, key, index) in systemLangBio" v-bind:key="index" :value="key">{{value}}</option>
              </select>
            </div>
            <!-- <div>
              <button class="rounded py-2 px-4 hover:bg-grey" @click="addWebBio(biosSelected)"><i class="fas fa-plus text-blue mt-1 mr-2"></i>Add Translation</button>
            </div> -->
          </div>
          <div>

          </div>
        </div>

        <div class="w-1/2 text-xs border-grey-lighter mb-4">
        <!-- start of sales bio -->
          <div v-for="(bio, name, index) in additionalLanguagesSales" :key="index" :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}">
            <div class="w-full px-2 mb-4">
              <div class="flex justify-between mb-1">
                <div><label for="self_biography" class="text-sm font-bold">Sales Particulars Biography - {{availableLangauges[name]}}:</label></div>
                <div>
                  <button class="rounded py-2 px-4 bg-grey flex items-center hover:bg-grey-dark" @click="removeBios(name, 'self_bio')"><icon :center="false" name="close_small" class="h-4 w-4"></icon>Delete</button>
                </div>
              </div>
              <div class="flex w-full justify-end">
                <div>
                  Character Count Limit:
                  <span class="ml-2" :class="{'text-red': value.userApproval.self_biography[name].length === 420, 'text-green': value.userApproval.self_biography[name].length < 420 }"> {{value.userApproval.self_biography[name] ? value.userApproval.self_biography[name].length : 0 }} / 420</span>
                </div>
              </div>
              <textarea :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}" type="text" id="self_biography" maxlength="420" v-model="value.userApproval.self_biography[name]" class="block w-full border p-2 mt-2 text-sm leading-normal" rows="15" placeholder="Paste your biography text in here"></textarea>
            </div>
          </div>
          <div v-if="Object.keys(value.userApproval.self_biography).length < 5" class="w-full mb-2 flex justify-end items-center">
            <div class="font-bold text-sm mr-4">Add a translation:</div>
            <div>
              <select :disabled="value.userApproval.status === 0" :class="{'opacity-25': value.userApproval.status === 0}"  v-model="salesSelected" @change="addSaleBio(salesSelected)" class="text-base px-4 py-2 bg-white border hover:bg-grey-light cursor-pointer" name="language" id="language">
                <option :value="null" disabled>Select Language</option>
                <option v-for="(value, key, index) in systemLangSales" v-bind:key="index" :value="key">{{value}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      v-if="selectLanguageModal"
      :scrollY="false"
      @dismissed="selectLanguageModal = false"
      @leave="selectLanguageModal = false"
      :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/4'"
    >
      <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <p class="text-center text-lg">Please select a Language</p>
        </div>
        <div class="flex items-center">
          <button  @click="selectLanguageModal = false" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            ok
          </button>
        </div>
      </div>
    </modal>
     <modal
      v-if="removelanguageModal"
      :scrollY="false"
      @dismissed="removelanguageModal = false"
      @leave="removelanguageModal = false"
      :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
    >
      <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <p class="text-center text-lg">Are you sure you want remove translation</p>
        </div>
        <div class="flex items-center">
          <button  @click="removeSelectedBio(removeLanguage,removeBiosType)" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Yes
          </button>
          <button  @click="removeLanguage = null, removeBiosType = null, removelanguageModal = null" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            No
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'
export default {
  name: 'ProfileBiography',
  props: ['value', 'errorBag'],
  computed: {
    ...mapState(['profile_v2', 'system']),
    additionalLanguagesSales () {
      let bios = JSON.parse(JSON.stringify(this.value))
      delete bios.userApproval.self_biography.en
      return bios.userApproval.self_biography
    },
    additionalLanguagesBio () {
      let salesBios = JSON.parse(JSON.stringify(this.value))
      delete salesBios.userApproval.website_biography.en
      return salesBios.userApproval.website_biography
    },
    systemLangBio () {
      if (!this.availableLangauges) {
        return {}
      }
      let tempAvailableLanguages = JSON.parse(JSON.stringify(this.availableLangauges))
      let keys = Object.keys(this.value.userApproval.website_biography)
      for (var key in tempAvailableLanguages) {
        if (keys.includes(key)) {
          delete tempAvailableLanguages[key]
        }
      }

      return tempAvailableLanguages
    },
    systemLangSales () {
      if (!this.availableLangauges) {
        return {}
      }
      let tempAvailableLanguages = JSON.parse(JSON.stringify(this.availableLangauges))
      let keys = Object.keys(this.value.userApproval.self_biography)
      for (var key in tempAvailableLanguages) {
        if (keys.includes(key)) {
          delete tempAvailableLanguages[key]
        }
      }
      return tempAvailableLanguages
    }
  },
  created () {
    // this.profile = this.profile_v2
    this.getAvailableLanguages()
  },
  data () {
    return {
      profile: null,
      loading: true,
      availableLangauges: {},
      biosSelected: null,
      salesSelected: null,
      selectLanguageModal: null,
      removelanguageModal: null,
      removeBiosType: null,
      removeLanguage: null
    }
  },
  methods: {
    ...mapActions([
      'updateProfileV2',
      'displayToastNotification'
    ]),
    addWebBio (value) {
      if (value === null) {
        this.selectLanguageModal = true
        return
      }
      this.$set(this.value.userApproval.website_biography, value, '')
      this.biosSelected = null
    },
    addSaleBio (value) {
      if (value === null) {
        this.selectLanguageModal = true
        return
      }
      this.$set(this.value.userApproval.self_biography, value, '')
      this.salesSelected = null
    },
    removeSelectedBio (value, type) {
      if (type === 'web_bios') {
        this.$delete(this.value.userApproval.website_biography, value)
      }
      if (type === 'self_bios') {
        this.$delete(this.value.userApproval.self_biography, value)
      }
      this.removeLanguage = null
      this.removeBiosType = null
      this.removelanguageModal = null
    },
    removeBios (value, type) {
      this.removelanguageModal = true
      if (type === 'self_bio') {
        this.removeBiosType = 'self_bios'
        this.removeLanguage = value
      }
      if (type === 'web_bio') {
        this.removeBiosType = 'web_bios'
        this.removeLanguage = value
      }
    },
    getAvailableLanguages () {
      api.get('/available-languages').then((response) => {
        this.availableLangauges = response.data
      })
    },
    saveBiography () {
      this.updateProfileV2(this.profile).then(esponse => {
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Profile biography Updated',
          info: 'Your user has been updated successfully.'
        })
      },
      error => {
        this.errorBag.store(error.response.data)
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Profile',
          info: 'Error saving profile biography.'
        })
      })
    }
  },
  watch: {
    profile: {
      handler (newVal, oldVal) {
        this.debounceMethod(newVal)
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
